<template>
  <section id="container" v-if="routerReady">
    <Toast />

    <AppHeader v-if="showHeader" />
    <SidebarMenu
      v-if="showSidebar"
      class="app-sidebar"
      @sidebarcall="toggleSidebar"
      :sidebarVisible="sidebarVisible"
    />
    <div
      :class="
        isClient && isLargeScreen && sidebarVisible ? 'not-expand' : 'expand'
      "
      :style="
        isClient && !isLargeScreen && sidebarVisible
          ? { opacity: 0.5 }
          : { opacity: 1 }
      "
    >
      <router-view></router-view>
      <Footer v-if="showFooter" />
    </div>
  </section>
</template>
<script>
import SidebarMenu from "@/components/layout/HeaderSidebar.vue";
import Toast from "primevue/toast";
import AppHeader from "@/components/layout/Header.vue";
import Footer from "@/components/layout/Footer.vue";
export default {
  components: {
    SidebarMenu,
    Toast,
    AppHeader,
    Footer,
  },
  data() {
    return {
      sidebarVisible:
        typeof window !== "undefined" ? window.innerWidth > 1024 : false,
      isLargeScreen:
        typeof window !== "undefined" ? window.innerWidth > 1024 : false,
      isClient: typeof window !== "undefined",
      routerReady: false,
    };
  },
  mounted() {
    this.isClient = true;
    this.updateScreenSize();
    window.addEventListener("resize", this.handleResize);
    // Wait for the router to be ready
    this.$router.isReady().then(() => {
      this.routerReady = true;
    });
  },
  beforeUnmount() {
    if (this.isClient) {
      window.removeEventListener("resize", this.handleResize);
    }
  },
  computed: {
    showHeader() {
      const path = this.$route.path.toLowerCase();
      const hideHeaderPaths = [
        "/login",
        "/register",
        "/forgot-password",
        // "/forgotpassword",
        "/dashboard",
        "/slotmanagement",
        "/categorylist",
        "/gamemanagement/create",
        "/gamemanagement/edit",
        "/gamelist",
        "/membershiplist",
        "/membership/create",
        "/membership/edit",
        "/gamebooking",
        "/planbooking",
        "/managemembership",
        "/reportlist",
        "/membershipreport",
        "/reward",
        "/gallerylist",
        "/notfound",
        "/userlist",
        "/admingamebooking",
        "/admingamebooking/create",
      ];
      // check if current path starts with any hide path
      return !hideHeaderPaths.some((p) => path.startsWith(p));
    },
    showSidebar() {
      const path = this.$route.path.toLowerCase();
      const hiddenPaths = [
        "/",
        "/home",
        "/login",
        "/register",
        "/forgot-password",
        // "/forgotpassword",
        "/privacypolicy",
        "/termscondition",
        "/contactus",
        "/rules-regulations",
        "/membership",
        "/mybooking",
        "/myplan",
        "/myaccount",
        "/notfound",
      ];
      return (
        !hiddenPaths.includes(path) && !path.startsWith("/membership/payment")
      );
    },
    showFooter() {
      const path = this.$route.path.toLowerCase();
      const hideHeaderPaths = [
        "/login",
        "/register",
        "/forgot-password",
        // "/forgotpassword",
        "/dashboard",
        "/slotmanagement",
        "/categorylist",
        "/gamemanagement/create",
        "/gamemanagement/edit",
        "/gamelist",
        "/membershiplist",
        "/membership/create",
        "/membership/edit",
        "/gamebooking",
        "/planbooking",
        "/managemembership",
        "/reportlist",
        "/membershipreport",
        "/reward",
        "/gallerylist",
        "/notfound",
        "/userlist",
        "/admingamebooking",
        "/admingamebooking/create",
      ];
      // check if current path starts with any hide path
      return !hideHeaderPaths.some((p) => path.startsWith(p));
    },
  },
  methods: {
    toggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    },
    handleResize() {
      this.updateScreenSize();
      if (!this.isLargeScreen) {
        this.sidebarVisible = false;
      } else {
        this.sidebarVisible = true;
      }
    },
    updateScreenSize() {
      this.isLargeScreen = window.innerWidth > 1024;
    },
  },
};
</script>
<style scoped>
#container {
  display: flex;
  overflow: auto;
  width: 100%;
}

.app-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.expand {
  margin-left: -240px;
  transition-timing-function: ease-in-out;
  transition: opacity 0.3s ease-in-out;
}

.not-expand {
  width: 100%;
  margin-left: 0px;
  transition-timing-function: ease-in-out;
  transition: opacity 0.3s ease-in-out;
}

@media (max-width: 1024px) {
  .expand,
  .not-expand {
    margin-left: 0;
    width: 100%;
    padding: 0;
  }
}
</style>
